import { NgModule } from "@angular/core";
import { UiTimePickerPanelComponent } from "./components/time-picker-panel/time-picker-panel.component";
import { UiTimePickerComponent } from "./time-picker.component";

@NgModule({
  imports: [UiTimePickerComponent, UiTimePickerPanelComponent],
  exports: [UiTimePickerComponent, UiTimePickerPanelComponent],
})
export class UiTimePickerModule {}
